import { useEffect } from "react";
import { useConfirm } from "src/components/Modalservice/UseConfirm";
import coursePartService from "src/coursepart/CoursePartService";
import { useI18n } from "src/utils/lni18n";


export default  function NavigateAwayFromPart() {

    const { languageService: t } = useI18n();
    const confirm = useConfirm();

    const checkPartDirty = async (partId: string, name:string) => {

        if (partId && coursePartService.isPartDirty(partId)) {

            const reply = await confirm("md",
                `${t.getText("coursepart")} : ${name}` || t.getText("close.editor"),
                <div className="preserve-white" >{t.getText("publish.before.close")}</div>);

            return reply;

        }
        else {
           return false;
        }



    }

    useEffect(() => {
        coursePartService.setDirtyGui(checkPartDirty);
        return () => coursePartService.setDirtyGui(()=>Promise.resolve(false));
    }, []);
    return <></>
}